import { Component, OnInit } from '@angular/core';
import { Osoba } from './osoba';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-osoba',
  templateUrl: './osoba.component.html'
})
export class OsobaComponent
 extends BaseModalContainer<Osoba>
  implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Osoba>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
